import makeStyles from '@mui/styles/makeStyles';
import { isDark } from 'global/styles';

const useStyles = makeStyles((theme) => ({
  sidebarWidth: {
    width: '300px',
    height: 'calc(100vh - 64px)',
    [theme.breakpoints.down('lg')]: {
      width: '0px',
    },
  },
  fullWidth: {
    width: '100%',
    height: 'calc(100vh - 64px)',
  },
  list: {
    overflowY: 'scroll',
    position: 'fixed',
    zIndex: 100,
    transition: (p) => (p.isMobile ? undefined : theme.transitions.create('width', { duration: theme.transitions.duration.complex })),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',

    '&.active': {
      backgroundColor: theme.palette.action.disabledBackground,
    },

    '&.disabled': {
      opacity: 0.5,
    },

    '& .mainRow': {
      alignItems: 'flex-start',
    },

    '& .textContainer': {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(3),
      alignItems: 'flex-start',
    },
  },
  closeIcon: {
    color: isDark(theme) ? theme.colors.white : theme.palette.primary.main,
  },
  divider: {
    borderBottom: `2px solid ${theme.palette.action.disabledBackground}`,
    marginBottom: theme.spacing(2),

    '& .dividertext': {
      marginBottom: -26,
      padding: theme.spacing(1),
      fontSize: 12,
      backgroundColor: theme.palette.background.default,
    },
  },
}));

export default useStyles;
